// Kept separate from Jobs.jsx so job components can use these without importing the Jobs route (circular import).
export const tabs = {
  PUBLIC_JOBS: 'publicjobs',
  MY_JOBS: 'myjobs'
};

export const subTabs = {
  SAVED: 'saved',
  APPLIED: 'applied'
};
